import { Container, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

interface Props {
  error?: string;
}

export const NotFoundPage = ({ error }: Props) => {
    return (
        <Container className="my-5">
            <Row className="justify-content-center">
                <Col md={12} style={{ color: "darkred" }}>
                    <h4>404 Not Found</h4>
                    <Link className="btn btn-primary mt-1" to="/">
                        Back to Home
                    </Link>
                </Col>
            </Row>
        </Container>
    );
};
